import StepsDescriptionStepComponent from './steps-description-step.component';

export default StepsDescriptionStepComponent;
